import frenchFlag from "@/assets/images/french_flag.svg";
import belgiumFlag from "@/assets/images/belgium_flag.svg";
import luxembourgFlag from "@/assets/images/luxembourg_flag.svg";
import cotedivoireFlag from "@/assets/images/cotedivoire_flag.svg";

export const SERVICE_ID = "rapsotec";
export const BIMDATA_STATUS = {
  SUCCESS: "SUCCESS",
  LOADING: "LOADING",
  ERROR: "ERROR",
};

export const COUNTRY_FLAG = [
  { value: "FR", image: frenchFlag },
  { value: "BE", image: belgiumFlag },
  { value: "LU", image: luxembourgFlag },
  { value: "CI", image: cotedivoireFlag },
];
